export default __webpack_public_path__ + "static/132-min-min-3868ae701011f847e6913eb55f20ab72.jpg";